import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import { formatIncome } from 'helpers/money.helper';
import { Progress } from 'antd';

const CreditAccountTipForCardBox = props => {
  const suggestedUsage = (props.creditLimit / 100) * 30;
  const overUsage = props.balance - suggestedUsage;

  return (
    <FlexContainer
      className={
        'format100 margT16 border-rad8px grayShadow16 padT16 padB24 padLR16 flex-column suggestedBarContainer'
      }
      style={{ height: '198px' }}
    >
      <Label className={'Subtitle-1'}>{'Tip for this card'}</Label>
      <Progress
        percent={100}
        success={{ percent: 30 }}
        strokeWidth={5}
        showInfo={false}
      />
      <FlexContainer className={'justify-between flex-column'}>
        <FlexContainer className={'justify-between'}>
          <FlexContainer className={'align-items-center'}>
            <div className={'circle bgLBlue3'}></div>
            <Label className={'Body-2 margL8'}>{'Suggested usage xxx'}</Label>
          </FlexContainer>

          <Label className={'Body-2 margL8 fontLBlue5'}>
            {formatIncome(suggestedUsage)}
          </Label>
        </FlexContainer>
        <FlexContainer className={'justify-between'}>
          <FlexContainer className={'align-items-center'}>
            <div className={'circle bgRed100'}></div>
            <Label className={'Body-2 margL8'}>
              {'Over suggested usage by'}
            </Label>
          </FlexContainer>

          <Label className={'Body-2 fontRed100'}>
            {formatIncome(overUsage)}
          </Label>
        </FlexContainer>
      </FlexContainer>
      <Label className={'Body-2 margT16'}>
        {`We recommend you reduce your usage by ${formatIncome(
          overUsage,
        )} or more for this card. Lenders like to see credit usage of 30% or lower.`}
      </Label>
    </FlexContainer>
  );
};

export default CreditAccountTipForCardBox;
